<template>
  <a-modal
    :title="isAdd ? '新建老师' : '修改老师'"
    :maskClosable="false"
    :width="1140"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      layout="horizontal"
      class="teacher-form"
      :form="form"
    >
      <div class="flex">
        <div class="" style="width: 55%">
          <!-- 头像上传 -->
          <a-form-model-item
            label="头像上传"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <c-upload
              accept="image/*"
              ossType="avatar"
              :isSingle="true"
              :maxFileSize="1048576"
              messageTitle="头像"
              @uploadSuccess="(url) => (form.avatarUrl = url)"
              :sourceFileList="sourceFileList_avatar"
            ></c-upload>
          </a-form-model-item>

          <!-- 正面免冠照片（2寸） -->
          <a-form-model-item
            label="正面免冠照片(2寸)"
            prop="ProtraitPhotoUrl"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_cardFront"
              :maxlength="1"
              :maxFileSize="204800"
              :imageMatchHeight="626"
              :imageMatchWidth="413"
              :isSingle="true"
              messageTitle="正面免冠照片"
              @uploadSuccess="uploadProtraitPhotoUrl"
              :sourceFileList="sourceFileListProtraitPhotoUrl"
            ></c-upload>
          </a-form-model-item>

          <!-- 老师名字 -->
          <a-form-model-item
            label="老师名字"
            prop="nickname"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-input
              type="text"
              v-model="form.nickname"
              @blur="onblurTeacherName"
            />
          </a-form-model-item>

          <!-- 性别 -->
          <a-form-model-item
            label="性别"
            prop="gender"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-select placeholder="请选择" v-model="form.gender">
              <a-select-option
                v-for="(item, index) in $store.getters.gender"
                :key="index"
                :value="item.value"
                >{{ item.code }}</a-select-option
              >
            </a-select>
          </a-form-model-item>

          <!-- 手机号 -->
          <a-form-model-item
            label="手机号"
            prop="mobile"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-input type="text" v-model="form.mobile" :maxLength="11" />
          </a-form-model-item>

          <!-- 执教年限 -->
          <a-form-model-item
            label="执教年限"
            prop="teachingYears"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-input-number
              :min="0"
              :max="100"
              v-model="form.teachingYears"
              style="width: 100%"
            />
          </a-form-model-item>

          <!-- 授课品类  placeholder='多个品类半角逗号","分隔' -->
          <a-form-model-item
            label="授课方向"
            prop="applyCourseType"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-input type="text" v-model="form.applyCourseType" @change="$forceUpdate()"/>
          </a-form-model-item>

          <!-- 银行卡号 -->
          <a-form-model-item
            label="银行卡号"
            prop="bankCardNo"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
            :maxLength="19"
          >
            <a-input type="text" v-model="form.bankCardNo" />
          </a-form-model-item>

          <!-- 开户行 -->
          <a-form-model-item
            label="开户行"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-input type="text" v-model="form.bankName" />
          </a-form-model-item>

          <!-- 身份证 -->
          <a-form-model-item
            label="身份证"
            prop="cardNo"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
            :maxLength="18"
          >
            <a-input type="text" v-model="form.cardNo" />
          </a-form-model-item>
          <!-- 老师介绍 -->
          <a-form-model-item
            label="老师介绍"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 14 } }"
          >
            <a-textarea
              placeholder="请输入"
              :max-length="100"
              :autoSize="{ minRows: 3, maxRows: 6 }"
              v-model="form.intro"
            />
          </a-form-model-item>
          <!-- 教育经历 -->
          <a-form-model-item
            style="display: flex"
            label="学位证与学历证"
            prop="degreeCertificatListString"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 16 } }"
          >
            <template>
              <div style="font-size: 0" v-for="(item, index) in form.degreeCertificatListString" :key="index">
                <div class="flex">
                  <a-select
                    placeholder="请选择学历"
                    class="select-xueli"
                    style="margin-right: 5px; width: 125px"
                    v-model="
                      form.degreeCertificatListString[index].eduBackground
                    "
                    @change="
                      $refs.ruleForm.validateField('degreeCertificatListString')
                    "
                  >
                    <a-select-option
                      v-for="(xitem, xindex) in xueli"
                      :key="xindex"
                      :value="xitem"
                      :disabled="
                        form.degreeCertificatListString.filter(
                          (iii) => iii.eduBackground === xitem
                        ).length !== 0
                      "
                      >{{ xitem }}</a-select-option
                    >
                  </a-select>
                  <a-input
                    style="width: 197px;"
                    placeholder="请输入毕业院校"
                    @input="
                      $refs.ruleForm.validateField('degreeCertificatListString')
                    "
                    v-model="form.degreeCertificatListString[index].text"
                  />
                  <a-button type="link" v-if="index>=1" style="color: #999;" @click="deleteDegreeCertificatItem(index)">
                    <a-icon type="delete" />
                  </a-button>
                </div>
                <div style="margin-top: 10px">
                  <c-upload
                    accept="image/*"
                    class="upload-xueli"
                    ossType="institution"
                    :isSingle="true"
                    :maxlength="1"
                    btnText="上传学历证"
                    @uploadSuccess="
                      uploadDegreeCertificat($event, index, 'photoUrl2')
                    "
                    ref="diploma"
                    :sourceFileList="form.degreeCertificatListString[index].photoUrl2List"
                  ></c-upload>
                  <c-upload
                    accept="image/*"
                    class="upload-xueli"
                    ossType="institution"
                    :isSingle="true"
                    :maxlength="1"
                    btnText="上传学位证"
                    @uploadSuccess="
                      uploadDegreeCertificat($event, index, 'photoUrl')
                    "
                    ref="degreeImgUrl"
                    :sourceFileList="form.degreeCertificatListString[index].photoUrlList"
                  ></c-upload>
                </div>
              </div>
            </template>
            <a-button
              v-if="form.degreeCertificatListString.length < 5"
              icon="plus-circle"
              @click="addDegreeCertificatItem"
              >新增</a-button
            >
          </a-form-model-item>
        </div>
        <!-- -------------------------------------------------------------------- -->
        <div class="" style="width: 45%">
          <!-- 健康证明 -->
          <a-form-model-item
            prop="heilthCertificate"
            label="健康证明(至多5张)"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_cardFront"
              :isSingle="false"
              :maxlength="5"
              @uploadSuccess="uploadSuccess_health"
              :sourceFileList="sourceFileListHealthCertificateUrl"
            ></c-upload>
          </a-form-model-item>

          <!-- 无犯罪证明 -->
          <a-form-model-item
            prop="noCriminal"
            label="无犯罪证明"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_cardFront"
              :isSingle="true"
              @uploadSuccess="(url) => (form.noCriminalUrl = url)"
              :sourceFileList="sourceFileListNoCriminalUrl"
            ></c-upload>
          </a-form-model-item>

          <!-- 无犯罪证明有效期 -->
          <a-form-model-item
            style="transform: translateY(-12px);"
            label="无犯罪证明有效期"
            prop="noCriminalExpiryDate"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <a-date-picker v-model="form.noCriminalExpiryDate" @change="$forceUpdate()"/>
          </a-form-model-item>

          <!-- 8分钟说课视频 -->
          <a-form-model-item
            label="8分钟说课视频"
            prop="talkingVideoUrl"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
            ><div v-if="form.talkingVideoUrl">
              <video
                style="height: 150px; width: 260px"
                controls="controls"
                muted="true"
                :src="form.talkingVideoUrl"
              ></video
              ><a
                class="view-link"
                :href="form.talkingVideoUrl"
                target="_blank"
                rel="noopener noreferrer"
                >查看</a
              ><a class="view-link" @click="uploadAgain">重新上传</a>
            </div>
            <c-upload
              v-if="sourceFileListTalkingVideoUrl.length == 0"
              accept="video/*"
              ossType="institution"
              ref="uploadVideo"
              :maxlength="1"
              :showUploadList="false"
              messageTitle="说课视频"
              :isSingle="false"
              @uploadSuccess="uploadVideo"
              :sourceFileList="sourceFileListTalkingVideoUrl"
            ></c-upload>
          </a-form-model-item>

          <!-- -------------------------------------------------------------------- -->
          <a-form-model-item
            prop="idCardFrontUrl"
            label="身份证正面照片"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_cardFront"
              :isSingle="true"
              @uploadSuccess="(url) => (form.cardFrontUrl = url)"
              :sourceFileList="sourceFileList_cardFront"
            ></c-upload>
          </a-form-model-item>

          <a-form-model-item
            prop="idCardBackUrl"
            label="身份证背面照片"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_cardBack"
              :isSingle="true"
              @uploadSuccess="(url) => (form.cardBackUrl = url)"
              :sourceFileList="sourceFileList_cardBack"
            ></c-upload>
          </a-form-model-item>

          <a-form-model-item
            label="老师资质证书"
            prop="credential"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_credential"
              :isSingle="false"
              :maxlength="5"
              @uploadSuccess="uploadCredentialUrl"
              :sourceFileList="sourceFileList_credential"
            ></c-upload>
          </a-form-model-item>
          <a-form-model-item
            prop="experience"
            title="校内教师本校任教证明/校外教师从业经验证明"
            label="校内教师本校任教证明/校外教师从业经验证明："
            :labelCol="{ rg: { span: 24 } }"
            :wrapperCol="{ lg: { span: 15, offset: 9 } }"
          >
            <c-upload
              accept="image/*"
              ossType="institution"
              ref="upload_experience"
              :isSingle="false"
              :maxlength="5"
              @uploadSuccess="uploadExperienceUrl"
              :sourceFileList="sourceFileList_experience"
            ></c-upload>
          </a-form-model-item>
        </div>
      </div>
    </a-form-model>
    <div class="btns">
      <a-button @click="handleCancel">取消</a-button>
      <a-button class="ml8" type="primary" @click="handleSubmit(0)">保存</a-button>
      <a-button class="ml8" type="primary" @click="handleSubmit(1)" v-if="showBtn">保存并提交审核</a-button>
    </div>
  </a-modal>
</template>

<script>
import teacher from '../../api/teacher'

import CUpload from '../../components/CUpload'

import school from '../../api/school'

import institution from '../../api/institution'

import { analysisAddress } from '../../utils/address'

import moment from 'moment'

export default {
  name: 'teacherFormModal',
  data() {
    return {
      xueli: ['专科', '本科', '研究生', '博士', '其他'],
      form: {
        nickname: '',
        gender: '',
        mobile: '',
        teachingYears: '',
        applyCourseType: '',
        bankCardNo: '',
        bankName: '',
        cardNo: '',
        intro: '',
        requiredSetting:[],
        /**
         * 教师资质URL回调
         */
        credentialUrl: '',
        /**
         * 法人身份证正面照片Url回调
         */
        cardFrontUrl: '',
        /**
         * 法人身份证反面照片Url回调
         */
        cardBackUrl: '',
        /**
         * 头像上传成功之后回调
         */
        avatarUrl: '',
        /**
         * 正面免冠照片url
         */
        protraitPhotoUrl: '',
        /**
         * 健康证明url
         */
        healthCertificateUrl: [],
        /**
         * 说课视屏url
         */
        talkingVideoUrl: '',
        /**
         * 无犯罪证明url
         */
        noCriminalUrl: '',
        /**
         * 学历学位证明url
         */
        degreeCertificatListString: [
          {
            /**
             * 教育背景 专科  本科  研究生  博士
             */
            eduBackground: undefined,
            text: '',
            photoUrl: '',
            photoUrl2: '',
            photoUrlList:[],
            photoUrl2List:[]
          },
        ],
        experience: [],
      },
      rules: {
        nickname: [{ required: true, message: '请输入' }],
        gender: [{ required: true, message: '请选择' }],
        mobile: [
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'change',
          },
        ],
        teachingYears: [
          {
            pattern: /^\d{1,100}$/,
            message: '请输入正整数',
            trigger: 'change',
          },
        ],
        bankCardNo: [
          {
            pattern: /^\d{16,19}$/,
            message: '请输入正确的银行卡号',
            trigger: 'change',
          },
        ],
        cardNo: [{ pattern: /^\w{15,18}$/, message: '请输入正确的身份证号' }],
        degreeCertificatListString: [
          {
            validator: this.checkdegreeCertificatListString,
          },
        ],
      },
      visible: false,
      confirmLoading: false,
      isAdd: true,
      teacherId: '',
      updateData: {},
      roleId: '', //角色ID
      reqDesc: {
        avatarUrl: '',
        credentialUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
      },

      sourceFileList_avatar: [], //头像回显
      sourceFileList_credential: [], //教师资质URL
      sourceFileList_experience: [], //从业经验URL
      sourceFileList_cardFront: [], //法人身份证正面照片Url
      sourceFileList_cardBack: [], //法人身份证反面照片Url

      sourceFileListProtraitPhotoUrl: [],
      sourceFileListHealthCertificateUrl: [],
      sourceFileListNoCriminalUrl: [],
      sourceFileListTalkingVideoUrl: [],
      /**
       * 0 是全部
       * 1 是单个验证
       */
      validateType: 1,
      showBtn: false,
    }
  },
  components: {
    CUpload,
  },
  methods: {
    //健康证明上传成的回调
    uploadSuccess_health(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.form.healthCertificateUrl = arr
    },
    uploadProtraitPhotoUrl(url) {
      this.form.protraitPhotoUrl = url
      this.sourceFileListProtraitPhotoUrl = []
      this.sourceFileListProtraitPhotoUrl.push(url)
    },
    uploadCredentialUrl(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.form.credentialUrl = arr
      // this.sourceFileList_credential = []
      // list.forEach((i) => {
      //   this.sourceFileList_credential.push(i.url)
      // })
      // this.form.credentialUrl = this.sourceFileList_credential.join(';')
    },
    uploadExperienceUrl(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.form.experience = arr
    },
    //初始化，显示
    init(type, params) {
      this.visible = true
      //URL回显
      this.sourceFileList_avatar = []
      this.sourceFileList_credential = []
      this.sourceFileList_cardFront = []
      this.sourceFileList_cardBack = []
      this.sourceFileList_experience = []
      this.isAdd = type === 'add' ? true : false

      //初始化form表单数据
      if (params) {
        console.log('params', params)
        this.updateData = params

        this.form.nickname = params.nickname
        this.form.mobile = params.mobile
        this.form.sourceType = params.sourceType.toString()
        this.form.intro = params.intro
        this.form.gender = params.gender.toString()
        this.form.teachingYears = params.teachingYears
        this.form.bankCardNo = params.bankCardNo
        this.form.bankName = params.bankName
        this.form.cardNo = params.cardNo
        this.form.avatarUrl = params.avatarUrl
        this.form.cardFrontUrl = params.cardFrontUrl
        this.form.cardBackUrl = params.cardBackUrl
        this.form.applyCourseType = params.applyCourseType
        if(params.noCrimeExpiryDate){
          this.form.noCriminalExpiryDate = moment(params.noCrimeExpiryDate[0].text)
        }
        //记录当前老师的ID
        this.teacherId = params.id
        this.userId = params.userId

        //URL回显
        this.sourceFileList_avatar.push(params.avatarUrl)
        if (params.credentialInfoUrl && params.credentialInfoUrl.length) {
          params.credentialInfoUrl.forEach((element) => {
            this.sourceFileList_credential.push(element.fileUrl)
          })
          this.form.credentialUrl = this.sourceFileList_credential.join(';')
        }
        if (params.experience && params.experience.length) {
          params.experience.forEach((element) => {
            this.sourceFileList_experience.push(element.fileUrl)
          })
          this.form.experience = this.sourceFileList_experience
        }
        this.sourceFileList_cardFront.push(params.cardFrontUrl)
        this.sourceFileList_cardBack.push(params.cardBackUrl)

        if (params.protraitPhotoUrl && params.protraitPhotoUrl.length) {
          this.sourceFileListProtraitPhotoUrl.push(
            params.protraitPhotoUrl[0].fileUrl
          )
          this.form.protraitPhotoUrl = params.protraitPhotoUrl[0].fileUrl
        }
        if (params.healthCertificateUrl && params.healthCertificateUrl.length) {
          this.sourceFileListHealthCertificateUrl =
            params.healthCertificateUrl.map((item) => {
              return item.fileUrl
            })
          this.form.healthCertificateUrl = params.healthCertificateUrl.map(
            (item) => {
              return item.fileUrl
            }
          )
        }
        if (params.noCriminalUrl && params.noCriminalUrl.length) {
          this.sourceFileListNoCriminalUrl.push(params.noCriminalUrl[0].fileUrl)
          this.form.noCriminalUrl = params.noCriminalUrl[0].fileUrl
        }
        if (params.talkingVideoUrl && params.talkingVideoUrl.length) {
          this.sourceFileListTalkingVideoUrl.push(
            params.talkingVideoUrl[0].fileUrl
          )
          this.form.talkingVideoUrl = params.talkingVideoUrl[0].fileUrl
        }
        if (params.degreeCertificatList && params.degreeCertificatList.length) {
          this.form.degreeCertificatListString = params.degreeCertificatList
            .map((item) => {
              /**
               * 1 是学位
               */
              const photoUrlList = item.teaTeacherInfoDos.filter(
                (item) => item.extType === 1
              ).map(i => i.fileUrl)
              const photoUrl = photoUrlList.length
                ? photoUrlList[0]
                : ''
              /**
               * 0 是学历
               */
              const photoUrl2List = item.teaTeacherInfoDos.filter(
                (item) => item.extType === 0
              ).map(i => i.fileUrl)
              const photoUrl2 = photoUrl2List.length
                ? photoUrl2List[0]
                : ''
              return {
                eduBackground: item.description,
                text: item.text,
                photoUrl,
                photoUrlList,
                photoUrl2,
                photoUrl2List
              }
            })
            .filter((item) => {
              console.log(item)
              return item.photoUrl || item.photoUrl2
            })
          if (!this.form.degreeCertificatListString.length) {
            this.form.degreeCertificatListString.push({
              eduBackground: undefined,
              text: '',
              photoUrl: '',
              photoUrl2: '',
            })
          }
          console.log(this.form.degreeCertificatListString)
        }
      } else {
        this.clearForm()
      }
    },

    uploadDegreeCertificat(url, index, key) {
      this.form.degreeCertificatListString[index][key] = url
      this.$refs.ruleForm.validateField('degreeCertificatListString')
    },
    deleteDegreeCertificatItem(index){
      this.form.degreeCertificatListString.splice(index,1)
    },
    addDegreeCertificatItem() {
      this.validateType = 1
      this.$refs.ruleForm.validateField(
        'degreeCertificatListString',
        (value) => {
          if (!value) {
            this.form.degreeCertificatListString.push({
              eduBackground: undefined,
              text: '',
              photoUrl: '',
              photoUrl2: '',
              photoUrlList:[],
              photoUrl2List:[]
            })
          }
        }
      )
    },
    uploadAgain() {
      this.form.talkingVideoUrl = null
      this.sourceFileListTalkingVideoUrl=[]
      // this.sourceFileListTalkingVideoUrl.pop()
    },
    
    //隐藏
    handleCancel() {
      this.visible = false
      this.clearForm()
      this.$refs.ruleForm.clearValidate()
      this.$emit('closeForm')
    },

    clearForm() {
      this.form = {
        nickname: '',
        gender: '',
        mobile: '',
        teachingYears: '',
        bankCardNo: '',
        bankName: '',
        cardNo: '',
        intro: '',
        /**
         * 教师资质URL回调
         */
        credentialUrl: '',
        credentialInfoUrl: [],
        /**
         * 法人身份证正面照片Url回调
         */
        cardFrontUrl: '',
        /**
         * 法人身份证反面照片Url回调
         */
        cardBackUrl: '',
        /**
         * 头像上传成功之后回调
         */
        avatarUrl: '',
        /**
         * 正面免冠照片url
         */
        protraitPhotoUrl: '',
        /**
         * 健康证明url
         */
        healthCertificateUrl: '',
        /**
         * 说课视屏url
         */
        talkingVideoUrl: '',
        /**
         * 无犯罪证明url
         */
        noCriminalUrl: '',
        /**
         * 学历学位证明url
         */
        degreeCertificatListString: [
          {
            /**
             * 教育背景 专科  本科  研究生  博士
             */
            eduBackground: undefined,
            text: '',
            photoUrl: '',
            photoUrl2: '',
            photoUrlList:[],
            photoUrl2List:[]
          },
        ],
      }
      this.sourceFileList_avatar = [] //头像回显
      this.sourceFileList_credential = [] //教师资质URL
      this.sourceFileList_cardFront = [] //法人身份证正面照片Url
      this.sourceFileList_cardBack = [] //法人身份证反面照片Url

      this.sourceFileListProtraitPhotoUrl = []
      this.sourceFileListHealthCertificateUrl = []
      this.sourceFileListNoCriminalUrl = []
      this.sourceFileListTalkingVideoUrl = []
    },

    checkdegreeCertificatListString(rule, value, callback) {
      const item = value[value.length - 1]
      if (
        this.validateType === 0 &&
        !item.eduBackground &&
        !item.photoUrl &&
        !item.photoUrl2
      ) {
        callback()
      }
      if (!item.eduBackground) {
        return callback(new Error('请正确选择学历'))
      }
      if (!this.form.degreeCertificatListString.every((item) => !!item.text)) {
        return callback(new Error('请正确输入毕业院校'))
      }
      if (!item.photoUrl2 && this.requiredSetting[0].settingValue=='1'){
        return callback(new Error('请正确上传学历证照片'))
      }
      if (!item.photoUrl && this.requiredSetting[1].settingValue=='1'){
        return callback(new Error('请正确上传学位证照片'))
      }
      callback()
    },

    //保存
    handleSubmit(type) {
      this.validateType = 0
      if(this.showBtn && type == 0){
        let num = 0
        this.$refs.ruleForm.validateField(['mobile','gender','nickname'], (valid) => {
          if(!valid) num += 1
          if(num==3){
            if(this.isAdd) {
              this.addTeacher(type)
            } else {
              this.updateTeacher(type)
            }
          }
        })
        return
      }
      //校验通过
      this.$refs.ruleForm.validate((valid) => {
        //表单校验通过
        if (valid) {
          //校验图片上传
          if (this.isAdd) {
            this.addTeacher(type)
          } else {
            this.updateTeacher(type)
          }
        } else {
          console.log(valid)
        }
      })
    },
    checkPic(){
      let flag = null
      if(this.requiredSetting[5].settingValue == '1' && !this.form.protraitPhotoUrl){
        this.$message.error('请上传2寸免冠照')
        return flag = false
      }
      if(this.requiredSetting[4].settingValue == '1' && !this.form.healthCertificateUrl){
        this.$message.error('请上传健康证明')
        return flag = false
      }
      if(this.requiredSetting[2].settingValue == '1' && !this.form.noCriminalUrl){
        this.$message.error('请上传无犯罪证明')
        return flag = false
      }
      if(this.requiredSetting[10].settingValue == '1' && !this.form.cardFrontUrl){
        this.$message.error('请上传身份证正面照片')
        return flag = false
      }
      if(this.requiredSetting[10].settingValue == '1' && !this.form.cardBackUrl){
        this.$message.error('请上传身份证背面照片')
        return flag = false
      }
      return flag = true
    },
    uploadVideo(list) {
      this.form.talkingVideoUrl = list[list.length - 1].url
      this.sourceFileListTalkingVideoUrl.push(this.form.talkingVideoUrl)
    },
    backParams() {
      let { degreeCertificatListString, ...params } = this.form
      let newParams = { ...params }
      if (newParams.noCriminalExpiryDate) {
        newParams.noCriminalExpiryDate = moment(newParams.noCriminalExpiryDate._d).format('YYYY-MM-DD')
      }
      if (Array.isArray(newParams.credentialUrl)) {
        newParams.credentialUrl = newParams.credentialUrl.join(';')
      }
      if (
        degreeCertificatListString[0].eduBackground &&
        (degreeCertificatListString[0].photoUrl ||
          degreeCertificatListString[0].photoUrl2)
      ) {
        newParams.degreeCertificatListString = JSON.stringify(
          degreeCertificatListString.filter((item) => {
            if (item.eduBackground) {
              if (!item.photoUrl) delete item.photoUrl
              if (!item.photoUrl2) delete item.photoUrl2
              if (!item.text) delete item.text
            }
            return item.eduBackground
          })
        )
      } else {
        newParams.degreeCertificatListString = ''
      }
      return newParams
    },

    //新增老师
    addTeacher(type) {
      const newParams = this.backParams()
      newParams.cardBackUrl = this.form.cardBackUrl
      newParams.cardFrontUrl = this.form.cardFrontUrl
      if(type){
        newParams.saveType = 1
      } else {
        newParams.saveType = this.showBtn ? 0 : 1
      }
      teacher.addTeacher(newParams).then((res) => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addTeacher', res.data)
      })
    },

    //修改老师
    updateTeacher(type) {
      const newParams = this.backParams()
      if(type){
        newParams.saveType = 1
      } else {
        newParams.saveType = this.showBtn ? 0 : 1
      }
      teacher.updateTeacher(this.userId, newParams).then((res) => {
        this.$message.success('修改成功')
        Object.assign(this.updateData, this.form)
        this.$emit('updateTeacher', res.data)
        this.handleCancel()
      })
    },
    // 检查含有中文的姓名中有空格，则自动去空格
    onblurTeacherName() {
      this.$nextTick(() => {
        let nickname = this.form.nickname
        const res = /^[0-9a-zA-Z ]+$/.test(nickname)
        if (nickname && !res) {
          const len = nickname.length
          nickname = nickname.replaceAll(' ', '')
          this.form.nickname = nickname
          if (len != nickname.length)
            this.$message.warning('姓名中不能包含空格，已经自动去空格')
        } else {
          this.form.nickname = nickname ? nickname.trim() : null
        }
      })
    },
    getTeacherRequiredFields(){
      let params = { type:this.roleId == 3? 1 :2 }
      school.getTeacherRequiredFields(params).then(res=>{
        this.requiredSetting = res.data.settingKeyValueDTOS
        this.rules = {
          ...this.rules,
          degreeCertificatListString:[{ required: this.requiredSetting[0].settingValue == '1' || this.requiredSetting[1].settingValue == '1',
            validator: this.checkdegreeCertificatListString,}],
          noCriminal:[{ required: this.requiredSetting[2].settingValue == '1', message:'' }],
          talkingVideoUrl:[{ required: this.requiredSetting[3].settingValue == '1', message:'' }],
          heilthCertificate:[{ required: this.requiredSetting[4].settingValue == '1', message:'' }],
          ProtraitPhotoUrl:[{ required: this.requiredSetting[5].settingValue == '1', message:'' }],
          credential:[{ required: this.requiredSetting[6].settingValue == '1', message:'' }],
          applyCourseType:[{ required: this.requiredSetting[7].settingValue == '1', message: '请输入' }],
          experience:[{ required: this.requiredSetting[8].settingValue == '1', message:'' }],
          noCriminalExpiryDate:[{ required: this.requiredSetting[9].settingValue == '1', message: '请输入' }],
          idCardFrontUrl:[{ required: this.requiredSetting[10].settingValue == '1', message: '' }],
          idCardBackUrl:[{ required: this.requiredSetting[10].settingValue == '1', message: '' }],
        }
      })
    },
    getBtnStatus(){
      if (this.roleId == 3) {
        this.showBtn = this.$ls.get('teaBureauSetting').find(item=>item.settingKey == 'school_teacher_status').settingValue == '1' ? true : false
      } else {
        this.showBtn = this.$ls.get('teaBureauSetting').find(item=>item.settingKey == 'noSchool_teacher_status').settingValue == '1' ? true : false
      }
      console.log(this.showBtn,'showBtn')
    }
  },
  created() {
    this.$store.dispatch('getUserInfo').then((res) => {
      this.roleId = res.accRole.id
      this.getTeacherRequiredFields()
      this.getBtnStatus()
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
::v-deep .ant-modal {
  margin-top: -55px;
}
.teacher-form {
  height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
}
.item1 {
  height: 102px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /deep/ .ant-upload {
    margin: 0;
  }
}
.select-xueli {
  width: 120px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: top;
}
.upload-xueli {
  display: inline-block;
}
.view-link {
  margin-right: 2em;
}
::v-deep .ant-modal-footer {
  display: none;
}
::v-deep .ant-modal-body {
  padding: 0;
}
.ant-form {
  // padding: 24px;
  margin: 24px;
}
.btns {
  text-align: right;
  padding: 10px 16px;
  border-top: 1px solid #e8e8e8;
}
.ml8 {
  margin-left: 8px;
}
</style>
